export enum SourceGroupTempEnum {
  Inactive,
  Active
}

export namespace SourceGroupTempEnum {
  export function values() {
    return Object.keys(SourceGroupTempEnum).filter(
      (type) => isNaN(<any>type) && type !== 'values'
    );
  }
}
